const routes = [
  {
    path: '/carAuthorization',
    name: 'carAuthorization',
    component: () => import('./pages/Home'),
    redirect: '/carAuthorization/index',
    meta: {
      requireAuth: false
    },
    children: [
      {
        path: 'index',
        name: 'carAuthorizationIndex',
        component: () => import('./pages/index'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
    ]
  }
]

export default routes